import React, { ReactElement } from 'react';
import { Typography } from 'fronton-react';
import { InfoBarWrapper, paragraphStyles } from './styles';

export type InfoBarType = 'warning' | 'alert';
export type InfoBarProps = {
	type: InfoBarType;
	icon: ReactElement;
	title: string;
	paragraph?: string;
	className?: string;
};

export const InfoBar = ({
	type = 'warning',
	icon,
	title,
	paragraph = null,
	className = '',
}: InfoBarProps) => (
	<InfoBarWrapper type={type} className={className} data-qa="infoBar">
		{icon}
		<div>
			<Typography variant="m" size="body_accent">
				{title}
			</Typography>
			{paragraph && (
				<Typography variant="s" size="body_long" className={paragraphStyles}>
					{paragraph}
				</Typography>
			)}
		</div>
	</InfoBarWrapper>
);
